/**
 * Constantes para las opciones de formularios HPS
 * Actualizado para usar valores legibles en lugar de códigos numéricos
 */

export const NATIONALITY_OPTIONS = [
  { value: "", label: "Seleccione una opción" },
  { value: "ESPAÑA", label: "ESPAÑA" },
  { value: "DESCONOCIDO", label: "DESCONOCIDO" },
  { value: "AFGANISTAN", label: "AFGANISTAN" },
  { value: "ALBANIA", label: "ALBANIA" },
  { value: "ALEMANIA", label: "ALEMANIA" },
  { value: "ANDORRA", label: "ANDORRA" },
  { value: "ANGOLA", label: "ANGOLA" },
  { value: "ANTIGUA Y BARBUDA", label: "ANTIGUA Y BARBUDA" },
  { value: "APATRIDA", label: "APATRIDA" },
  { value: "ARABIA SAUDITA", label: "ARABIA SAUDITA" },
  { value: "ARGELIA", label: "ARGELIA" },
  { value: "ARGENTINA", label: "ARGENTINA" },
  { value: "ARMENIA", label: "ARMENIA" },
  { value: "ARUBA", label: "ARUBA" },
  { value: "AUSTRALIA", label: "AUSTRALIA" },
  { value: "AUSTRIA", label: "AUSTRIA" },
  { value: "AZERBAIYAN", label: "AZERBAIYAN" },
  { value: "BAHAMAS (LAS)", label: "BAHAMAS (LAS)" },
  { value: "BAHREIN", label: "BAHREIN" },
  { value: "BANGLADESH", label: "BANGLADESH" },
  { value: "BARBADOS", label: "BARBADOS" },
  { value: "BELARUS (BIELORRUSIA)", label: "BELARUS (BIELORRUSIA)" },
  { value: "BELGICA", label: "BELGICA" },
  { value: "BELICE", label: "BELICE" },
  { value: "BENIN", label: "BENIN" },
  { value: "BERMUDAS", label: "BERMUDAS" },
  { value: "BHUTAN (BUTAN)", label: "BHUTAN (BUTAN)" },
  { value: "BOLIVIA", label: "BOLIVIA" },
  { value: "BOSNIA Y HERZEGOVINA", label: "BOSNIA Y HERZEGOVINA" },
  { value: "BOTSWANA (BOSTSUANA)", label: "BOTSWANA (BOSTSUANA)" },
  { value: "BRASIL", label: "BRASIL" },
  { value: "BRUNEI DARUSSALAM", label: "BRUNEI DARUSSALAM" },
  { value: "BULGARIA", label: "BULGARIA" },
  { value: "BURKINA FASO", label: "BURKINA FASO" },
  { value: "BURUNDI", label: "BURUNDI" },
  { value: "CABO VERDE", label: "CABO VERDE" },
  { value: "CAIMAN, ISLAS", label: "CAIMAN, ISLAS" },
  { value: "CAMBOYA", label: "CAMBOYA" },
  { value: "CAMERUN", label: "CAMERUN" },
  { value: "CANADA", label: "CANADA" },
  { value: "CHAD", label: "CHAD" },
  { value: "CHEQUIA (REPUBLICA CHECA)", label: "CHEQUIA (REPUBLICA CHECA)" },
  { value: "CHILE", label: "CHILE" },
  { value: "CHINA", label: "CHINA" },
  { value: "CHIPRE", label: "CHIPRE" },
  { value: "COLOMBIA", label: "COLOMBIA" },
  { value: "CONGO", label: "CONGO" },
  { value: "CONGO (REPUBLICA DEMOCRATICA DEL)", label: "CONGO (REPUBLICA DEMOCRATICA DEL)" },
  { value: "COREA DEL NORTE", label: "COREA DEL NORTE" },
  { value: "COREA DEL SUR", label: "COREA DEL SUR" },
  { value: "COSTA RICA", label: "COSTA RICA" },
  { value: "COTE D'IVOIRE (COSTA DE MARFIL)", label: "COTE D'IVOIRE (COSTA DE MARFIL)" },
  { value: "CROACIA", label: "CROACIA" },
  { value: "CUBA", label: "CUBA" },
  { value: "DINAMARCA", label: "DINAMARCA" },
  { value: "DJIBOUTI (YIBUTI)", label: "DJIBOUTI (YIBUTI)" },
  { value: "DOMINICA", label: "DOMINICA" },
  { value: "DOMINICANA (REPUBLICA)", label: "DOMINICANA (REPUBLICA)" },
  { value: "ECUADOR", label: "ECUADOR" },
  { value: "EGIPTO", label: "EGIPTO" },
  { value: "EL SALVADOR", label: "EL SALVADOR" },
  { value: "EMIRATOS ARABES UNIDOS", label: "EMIRATOS ARABES UNIDOS" },
  { value: "ERITREA", label: "ERITREA" },
  { value: "ESLOVAQUIA", label: "ESLOVAQUIA" },
  { value: "ESLOVENIA", label: "ESLOVENIA" },
  { value: "ESTADOS UNIDOS", label: "ESTADOS UNIDOS" },
  { value: "ESTONIA", label: "ESTONIA" },
  { value: "ETIOPIA", label: "ETIOPIA" },
  { value: "FIJI (FIYI)", label: "FIJI (FIYI)" },
  { value: "FILIPINAS", label: "FILIPINAS" },
  { value: "FINLANDIA", label: "FINLANDIA" },
  { value: "FRANCIA", label: "FRANCIA" },
  { value: "GABON", label: "GABON" },
  { value: "GAMBIA", label: "GAMBIA" },
  { value: "GEORGIA", label: "GEORGIA" },
  { value: "GHANA", label: "GHANA" },
  { value: "GRANADA", label: "GRANADA" },
  { value: "GRECIA", label: "GRECIA" },
  { value: "GUADALOUPE (GUADALUPE)", label: "GUADALOUPE (GUADALUPE)" },
  { value: "GUATEMALA", label: "GUATEMALA" },
  { value: "GUAYANA FRANCESA", label: "GUAYANA FRANCESA" },
  { value: "GUINEA", label: "GUINEA" },
  { value: "GUINEA BISSAU", label: "GUINEA BISSAU" },
  { value: "GUINEA ECUATORIAL", label: "GUINEA ECUATORIAL" },
  { value: "GUYANA", label: "GUYANA" },
  { value: "HAITI", label: "HAITI" },
  { value: "HONDURAS", label: "HONDURAS" },
  { value: "HONG KONG", label: "HONG KONG" },
  { value: "HUNGRIA", label: "HUNGRIA" },
  { value: "INDIA", label: "INDIA" },
  { value: "INDONESIA", label: "INDONESIA" },
  { value: "IRAN", label: "IRAN" },
  { value: "IRAQ", label: "IRAQ" },
  { value: "IRLANDA", label: "IRLANDA" },
  { value: "ISLANDIA", label: "ISLANDIA" },
  { value: "ISRAEL", label: "ISRAEL" },
  { value: "ITALIA", label: "ITALIA" },
  { value: "JAMAICA", label: "JAMAICA" },
  { value: "JAPON", label: "JAPON" },
  { value: "JORDANIA", label: "JORDANIA" },
  { value: "KAZAJSTAN (KAZAJISTAN)", label: "KAZAJSTAN (KAZAJISTAN)" },
  { value: "KENYA (KENIA)", label: "KENYA (KENIA)" },
  { value: "KIRGUISTAN", label: "KIRGUISTAN" },
  { value: "KIRIBATI", label: "KIRIBATI" },
  { value: "KUWAIT", label: "KUWAIT" },
  { value: "LAO (LAOS)", label: "LAO (LAOS)" },
  { value: "LESOTHO", label: "LESOTHO" },
  { value: "LETONIA", label: "LETONIA" },
  { value: "LIBANO", label: "LIBANO" },
  { value: "LIBERIA", label: "LIBERIA" },
  { value: "LIBIA", label: "LIBIA" },
  { value: "LIECHTENSTEIN", label: "LIECHTENSTEIN" },
  { value: "LITUANIA", label: "LITUANIA" },
  { value: "LUXEMBURGO", label: "LUXEMBURGO" },
  { value: "MACEDONIA DEL NORTE", label: "MACEDONIA DEL NORTE" },
  { value: "MADAGASCAR", label: "MADAGASCAR" },
  { value: "MALASIA", label: "MALASIA" },
  { value: "MALAWI (MALAUI)", label: "MALAWI (MALAUI)" },
  { value: "MALDIVAS", label: "MALDIVAS" },
  { value: "MALI", label: "MALI" },
  { value: "MALTA", label: "MALTA" },
  { value: "MALVINAS (FALKLAND), ISLAS", label: "MALVINAS (FALKLAND), ISLAS" },
  { value: "MARRUECOS", label: "MARRUECOS" },
  { value: "MAURITANIA", label: "MAURITANIA" },
  { value: "MEXICO", label: "MEXICO" },
  { value: "MOLDOVA (MOLDAVIA)", label: "MOLDOVA (MOLDAVIA)" },
  { value: "MONACO", label: "MONACO" },
  { value: "MONGOLIA", label: "MONGOLIA" },
  { value: "MONTENEGRO", label: "MONTENEGRO" },
  { value: "MOZAMBIQUE", label: "MOZAMBIQUE" },
  { value: "MYANMAR", label: "MYANMAR" },
  { value: "NAMIBIA", label: "NAMIBIA" },
  { value: "NEPAL", label: "NEPAL" },
  { value: "NICARAGUA", label: "NICARAGUA" },
  { value: "NIGER", label: "NIGER" },
  { value: "NIGERIA", label: "NIGERIA" },
  { value: "NORUEGA", label: "NORUEGA" },
  { value: "NUEVA ZELANDA", label: "NUEVA ZELANDA" },
  { value: "OMAN", label: "OMAN" },
  { value: "PAISES BAJOS", label: "PAISES BAJOS" },
  { value: "PAKISTAN", label: "PAKISTAN" },
  { value: "PALESTINA", label: "PALESTINA" },
  { value: "PANAMA", label: "PANAMA" },
  { value: "PARAGUAY", label: "PARAGUAY" },
  { value: "PERU", label: "PERU" },
  { value: "POLINESIA FRANCESA", label: "POLINESIA FRANCESA" },
  { value: "POLONIA", label: "POLONIA" },
  { value: "PORTUGAL", label: "PORTUGAL" },
  { value: "PUERTO RICO", label: "PUERTO RICO" },
  { value: "QATAR (CATAR)", label: "QATAR (CATAR)" },
  { value: "REINO UNIDO DE GRAN BRETAÑA E IRLANDA DEL NORTE", label: "REINO UNIDO DE GRAN BRETAÑA E IRLANDA DEL NORTE" },
  { value: "REPUBLICA CENTROAFRICANA", label: "REPUBLICA CENTROAFRICANA" },
  { value: "RUMANIA", label: "RUMANIA" },
  { value: "RUSIA", label: "RUSIA" },
  { value: "RWANDA (RUANDA)", label: "RWANDA (RUANDA)" },
  { value: "SAHARA OCCIDENTAL (REPUBLICA ARABE SAHARAUI DEMOCRATICA)", label: "SAHARA OCCIDENTAL (REPUBLICA ARABE SAHARAUI DEMOCRATICA)" },
  { value: "SANTO TOME Y PRINCIPE", label: "SANTO TOME Y PRINCIPE" },
  { value: "SENEGAL", label: "SENEGAL" },
  { value: "SERBIA", label: "SERBIA" },
  { value: "SEYCHELLES", label: "SEYCHELLES" },
  { value: "SIERRA LEONA", label: "SIERRA LEONA" },
  { value: "SINGAPUR", label: "SINGAPUR" },
  { value: "SIRIA", label: "SIRIA" },
  { value: "SOMALIA", label: "SOMALIA" },
  { value: "SRI LANKA (CEILAN)", label: "SRI LANKA (CEILAN)" },
  { value: "SUDAFRICA", label: "SUDAFRICA" },
  { value: "SUDAN", label: "SUDAN" },
  { value: "SUDAN DEL SUR", label: "SUDAN DEL SUR" },
  { value: "SUECIA", label: "SUECIA" },
  { value: "SUIZA", label: "SUIZA" },
  { value: "TAILANDIA", label: "TAILANDIA" },
  { value: "TAIWAN", label: "TAIWAN" },
  { value: "TANZANIA", label: "TANZANIA" },
  { value: "TAYIKISTAN", label: "TAYIKISTAN" },
  { value: "TOGO", label: "TOGO" },
  { value: "TONGA", label: "TONGA" },
  { value: "TRINIDAD Y TOBAGO", label: "TRINIDAD Y TOBAGO" },
  { value: "TUNEZ", label: "TUNEZ" },
  { value: "TURKMENISTAN", label: "TURKMENISTAN" },
  { value: "TURQUIA", label: "TURQUIA" },
  { value: "UCRANIA", label: "UCRANIA" },
  { value: "UGANDA", label: "UGANDA" },
  { value: "URUGUAY", label: "URUGUAY" },
  { value: "UZBEKISTAN", label: "UZBEKISTAN" },
  { value: "VENEZUELA", label: "VENEZUELA" },
  { value: "VIETNAM", label: "VIETNAM" },
  { value: "YEMEN", label: "YEMEN" },
  { value: "ZAMBIA", label: "ZAMBIA" },
  { value: "ZIMBABWE (ZIMBABUE)", label: "ZIMBABWE (ZIMBABUE)" }
];

export const DOCUMENT_TYPE_OPTIONS = [
  { value: "", label: "Seleccione una opción" },
  { value: "DNI / NIF", label: "DNI / NIF" },
  { value: "NIE", label: "NIE" },
  { value: "Tarjeta Residente", label: "Tarjeta Residente" },
  { value: "Pasaporte", label: "Pasaporte" },
  { value: "Otros", label: "Otros" }
];

export const REQUEST_TYPE_OPTIONS = [
  { value: "new", label: "Nueva" },
  { value: "renewal", label: "Renovación" }
];